<!-- https://8es9hr.axshare.com/#p=%E6%96%B0%E5%A2%9E%E9%80%80%E4%BF%9D%E7%94%B3%E8%AB%8B&g=1 -->
<!-- 新增退保申請 -->
<template>
    <div class="row">
        <div class="col-12">
            <div class="col-block">
                <div class="block-header has-border">
                    <h3>
                        <strong>退保作業</strong>
                    </h3>
                </div>
                <div class="block-content">
                    <el-tabs type="border-card">
                        <el-tab-pane label="基本資料">
                            <el-form label-position="top">
                                <el-form-item label="請選擇身份別" v-if="false">
                                    <el-select
                                        v-model="recordToEdit.employeeType"
                                        placeholder="請選擇身份別"
                                    >
                                        <el-option
                                            v-for="(item,index) in titleList"
                                            :key="index"
                                            :label="item.label"
                                            :value="item.value"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label v-if="id ==  0">
                                    <ListForm
                                        :id="id"
                                        labelPosition="top"
                                        :recordToEdit="recordToEdit"
                                        :formType="formType"
                                        ref="memberGet"
                                        class="listFormSet"
                                    >
                                        <div slot="footer" class="dialog-footer"></div>
                                    </ListForm>
                                </el-form-item>

                                <el-form-item label="確認申請人資料" v-show="show && id== 0">
                                    <table class="table table-bordered mb-0">
                                        <tbody>
                                            <tr>
                                                <td>是否為社員</td>
                                                <td
                                                    v-if="recordToEdit.isMember==1"
                                                >{{'是'}} {{ recordToEdit.memberAccount }}</td>
                                                <td v-else>否</td>
                                            </tr>
                                            <tr>
                                                <td>姓名</td>
                                                <td>
                                                    <el-input
                                                        class="mt10 mb10"
                                                        v-model="recordToEdit.name"
                                                    ></el-input>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>性別</td>
                                                <td>
                                                    <el-radio-group v-model="recordToEdit.sex">
                                                        <el-radio :label="1">男</el-radio>
                                                        <el-radio :label="2">女</el-radio>
                                                    </el-radio-group>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>證件號碼 (身分證/居留證等)</td>
                                                <td>
                                                    <el-input
                                                        class="mt10 mb10"
                                                        v-model="recordToEdit.idNumber"
                                                    ></el-input>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>出生年月</td>
                                                <td>
                                                    <div class="date mt10">
                                                        <input
                                                            type="text"
                                                            class="min_go_date birthday1 birthday"
                                                            placeholder="選擇日期"
                                                        />
                                                        <span class="el-input__prefix">
                                                            <i class="el-icon-date"></i>
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>職稱</td>
                                                <td>
                                                    <el-input
                                                        class="mt10 mb10"
                                                        v-model="recordToEdit.title"
                                                    ></el-input>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>任期</td>
                                                <td>
                                                    <div class="date mt10">
                                                        <input
                                                            type="text"
                                                            class="min_go_date EmployeeStartDate1 EmployeeStartDate"
                                                            placeholder="選擇日期"
                                                        />
                                                        <span class="el-input__prefix">
                                                            <i class="el-icon-date"></i>
                                                        </span>
                                                    </div>~
                                                    <div class="date">
                                                        <input
                                                            type="text"
                                                            class="min_go_date EmployeeEndDate1 EmployeeEndDate"
                                                            placeholder="選擇日期"
                                                        />
                                                        <span class="el-input__prefix">
                                                            <i class="el-icon-date"></i>
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </el-form-item>
                                <el-form-item label="確認申請人資料" v-if="id !== 0">
                                    <table class="table table-bordered mb-0">
                                        <tbody>
                                            <tr>
                                                <td>是否為社員</td>
                                                <td
                                                    v-if="recordToEdit.isMember==1"
                                                >{{'是'}} {{ recordToEdit.memberAccount }}</td>
                                                <td v-else>否</td>
                                            </tr>
                                            <tr>
                                                <td>姓名</td>
                                                <td>
                                                    <el-input
                                                        class="mt10 mb10"
                                                        v-model="recordToEdit.name"
                                                    ></el-input>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>性別</td>
                                                <td>
                                                    <el-radio
                                                        v-model="recordToEdit.sex"
                                                        :label="2"
                                                    >女性</el-radio>
                                                    <el-radio
                                                        v-model="recordToEdit.sex"
                                                        :label="1"
                                                    >男性</el-radio>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>證件號碼 (身分證/居留證等)</td>
                                                <td>
                                                    <el-input
                                                        class="mt10 mb10"
                                                        v-model="recordToEdit.idNumber"
                                                    ></el-input>
                                                    <!-- <el-button type="primary"
                                                       plain
                                                       size="small"
                                                    @click="getMemberData">查詢</el-button>-->
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>出生年月</td>
                                                <td>
                                                    <div class="date mt10">
                                                        <input
                                                            type="text"
                                                            class="min_go_date birthday1 birthday"
                                                            placeholder="選擇日期"
                                                        />
                                                        <span class="el-input__prefix">
                                                            <i class="el-icon-date"></i>
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>職稱</td>
                                                <td>
                                                    <el-input
                                                        class="mt10 mb10"
                                                        v-model="recordToEdit.title"
                                                    ></el-input>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>任期</td>
                                                <td>
                                                    <div class="date mt10">
                                                        <input
                                                            type="text"
                                                            class="min_go_date EmployeeStartDate1 EmployeeStartDate"
                                                            placeholder="選擇日期"
                                                        />
                                                        <span class="el-input__prefix">
                                                            <i class="el-icon-date"></i>
                                                        </span>
                                                    </div>~
                                                    <div class="date">
                                                        <input
                                                            type="text"
                                                            class="min_go_date EmployeeEndDate1 EmployeeEndDate"
                                                            placeholder="選擇日期"
                                                        />
                                                        <span class="el-input__prefix">
                                                            <i class="el-icon-date"></i>
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-if="false">
                                                <td>申請變更項目</td>
                                                <td>
                                                    <el-checkbox-group
                                                        v-model="recordToEdit.applyType"
                                                    >
                                                        <el-checkbox
                                                            v-for="item in applyType"
                                                            :label="item.label"
                                                            :key="item.value"
                                                        >{{ item.label }}</el-checkbox>
                                                    </el-checkbox-group>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>身份別</td>
                                                <td>{{recordToEdit.allEmployeeType}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </el-form-item>
                                <el-form-item label="申請方案" v-if="show">
                                    {{subName}}
                                </el-form-item>
                            </el-form>
                            <el-button
                                type="primary"
                                v-if="!isSubmit && recordToEdit.isSubmit !==1"
                                @click="saveMainEdit"
                                plain
                                :disabled="!show"
                            >暫存</el-button>
                            <el-button
                                type="primary"
                                v-if="!isSubmit && id !== 0 && recordToEdit.isSubmit !==1"
                                @click="submit"
                            >送出</el-button>
                            <el-button @click="back">取消</el-button>
                        </el-tab-pane>
                        <el-tab-pane label="申請結果" v-if="id == 0">
                            <el-form label-position="top">
                                <el-form-item label="申請日期">{{recordToEdit.sendGenDate}}</el-form-item>
                                <el-form-item label="協會送件日期">
                                    <div class="date mt10">
                                        <input
                                            type="text"
                                            class="min_go_date genSendDate1 genSendDate"
                                            placeholder="選擇日期"
                                            :disabled="true"
                                        />
                                        <span class="el-input__prefix">
                                            <i class="el-icon-date"></i>
                                        </span>
                                    </div>
                                </el-form-item>
                                <el-form-item label="協會送件郵局存根條碼">
                                    <el-input v-model="recordToEdit.genSendCode" :disabled="true"></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="核保狀態"
                                >{{underwriteStatusBack[recordToEdit.underwriteStatus]}}</el-form-item>
                                <!--如果不是加保通過就不顯示-->
                                <el-form-item
                                    v-if="recordToEdit.underwriteStatus === 3 "
                                    label="退費狀態"
                                >{{refoundStatus[recordToEdit.refoundStatus]}}</el-form-item>
                                <el-form-item
                                    label="退費金額"
                                    v-if="recordToEdit.underwriteStatus === 3 "
                                >{{recordToEdit.backAmount}}</el-form-item>
                                <el-form-item label="補件狀態">{{addDocStatus[recordToEdit.needAddDoc]}}</el-form-item>
                                <el-form-item label="補件日期">{{recordToEdit.addDocDate}}</el-form-item>
                                <el-form-item label="補件原因">{{recordToEdit.addDocReason}}</el-form-item>
                            </el-form>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { API } from "@/assets/config";
import ListForm from "@/components/ListForm.vue";
export default {
    name: "Employee_surrenderroster_edit",
    components: {
        ListForm
    },
    data() {
        return {
            id:
                this.$route.params.subId == "new"
                    ? 0
                    : this.$route.params.subId,
            member: {},
            code: localStorage.getItem("codeValue"),
            isSubmit: false,
            api: "coopInsEmployeeMemberApply",
            apiBnf: "coopInsEmployeeMemberApplyBnf",
            recordToEdit: {
                employeeType: "",
                memberData: ""
            },
            toolbar: {},
            sub: {},
            subName: "",
            payment: {},
            account: this.$route.params.account || "",
            show: false,
            dialogListForm: false,
            currentEdit: {},
            setTimeKey: [
                "birthday",
                "EmployeeStartDate",
                "EmployeeEndDate",
                "genSendDate"
            ],
            addDocStatus: {},
            underwriteStatusBack: {},
            cardSendStatus: {},
            refoundStatus: {},
            formType: [
                {
                    label: "選擇申請人",
                    key: "memberData",
                    type: "chooseMember",
                    searchMember: false,
                    api: "coopInsEmployeeMember",
                    placeholder: "從參加名冊中選擇生效中的申請人",
                    filter: {
                        insEmployeeYearId: 0,
                        underwriteStatus: 1
                    },
                    query: {
                        insEmployeeMainCode: this.$route.params.code
                    },
                    columns: [
                        {
                            prop: "memberAccount",
                            label: "社員帳號"
                        },
                        {
                            prop: "name",
                            label: "社員姓名"
                        },
                        {
                            prop: "subName",
                            label: "申請子方案"
                        },
                        {
                            label: "核保狀態",
                            prop: "underwriteStatus",
                            renderFunction(h, scope, enumData) {
                                return h(
                                    "div",
                                    enumData.insEmployeeUnderwriteStatus[
                                        scope.row.underwriteStatus
                                    ]
                                );
                            }
                        }
                    ]
                }
            ],
            titleList: []
        };
    },
    created() {
        this.getData();
    },
    mounted() {
        const vm = this;
        $(".min_go_date").datepicker({
            changeYear: true,
            changeMonth: true,
            currentText: "今天",
            dateFormat: "Rmmdd",
            showButtonPanel: true,
            yearRange: "1912:c+10",
            onSelect(data) {
                let key = $(this)[0].className.split(" ")[2];
                if (data) {
                    vm.recordToEdit[key] =
                        parseInt(data.split("-")[0]) +
                        1911 +
                        "-" +
                        data.slice(4);
                }
            }
        });
    },
    watch: {
        "recordToEdit.memberData.idNumber": {
            handler(newKey) {
                this.schMember(newKey, this.recordToEdit.employeeType);
            }
        }
    },
    methods: {
        getData() {
            const vm = this;
            let url =
                API[this.api] +
                `?id=${this.id}&insEmployeeMainCode=${localStorage.getItem(
                    "codeValue"
                )}`;
            const thenCB = json => {
                this.recordToEdit = Object.assign(
                    {},
                    this.recordToEdit,
                    json.resultData.data
                );
                this.isSubmit = json.resultData.data.isSubmit == 1;
                // this.schMember(json.resultData.data.idNumber);
                // this.schMember("", json.resultData.data.memberId);
                this.underwriteStatusBack =
                    json.resultData.enumData.insEmployeeUnderwriteStatusBack;
                this.cardSendStatus =
                    json.resultData.enumData.insEmployeeApplyCardSendStatus;
                this.refoundStatus =
                    json.resultData.enumData.insEmployeeApplyRefoundStatus;
                this.addDocStatus =
                    json.resultData.enumData.insEmployeeApplyAddDocStatus;
                
                let title = json.resultData.enumData.hireTitle;
                
                this.titleList = Object.keys(title)
                    .map((key) => {
                        return {
                            label: title[key],
                            value: parseInt(key),
                        };
                    })
                    .slice(0, 2);

                if (this.id == 0) {
                    // chooseMember fitler 年度
                    this.formType[0].filter.insEmployeeYearId =
                        json.resultData.enumData.insEmployeeYear[0].id;
                } else if (this.recordToEdit.idNumber) {
                    this.schMember(this.recordToEdit.idNumber);
                }
                setTimeout(() => {
                    this.setTimeKey.forEach(item => {
                        $(`.${item}`).val(
                            `${
                                parseInt(json.resultData.data[item]) - 1911 <
                                100
                                    ? `0${parseInt(json.resultData.data[item]) -
                                          1911}${
                                          json.resultData.data[item]
                                              .slice(4)
                                              .split(" ")[0]
                                      }`
                                    : `${parseInt(json.resultData.data[item]) -
                                          1911}${
                                          json.resultData.data[item]
                                              .slice(4)
                                              .split(" ")[0]
                                      }` || ""
                            }`
                        );
                    });
                }, 1);
            };

            this.mAxiosGet(url, thenCB);
        },
        schMember(account = 0, employeeType = 0) {
            this.show = false;
            let url =
                API.coopInsEmployeeMember +
                `?action=getEmployeeByMember&idNumber=${account}&insEmployeeMainCode=${localStorage.getItem(
                    "codeValue"
                )}&employeeType=${employeeType}`;
            const thenCB = json => {
                this.recordToEdit = Object.assign(
                    {},
                    this.recordToEdit,
                    json.resultData.data
                );
                this.member = json.resultData.data;
                this.subName = json.resultData.enumData.sub.name;
                setTimeout(() => {
                    this.setTimeKey.forEach(item => {
                        $(`.${item}`).val("");
                        $(`.${item}`).val(
                            `${
                                parseInt(json.resultData.data[item]) - 1911 <
                                100
                                    ? `0${parseInt(json.resultData.data[item]) -
                                          1911}${
                                          json.resultData.data[item]
                                              .slice(4)
                                              .split(" ")[0]
                                      }`
                                    : `${parseInt(json.resultData.data[item]) -
                                          1911}${
                                          json.resultData.data[item]
                                              .slice(4)
                                              .split(" ")[0]
                                      }` || ""
                            }`
                        );
                    });
                }, 1);
                this.show = true;
            };
            this.mAxiosGet(url, thenCB);
        },
        async submit() {
            // 先 await 暫存，避免 update 與 submit 並行造成 race
            try {
                await this.saveMainEdit({ silent: true });
            
                let url = API.coopInsEmployeeMemberApply + `?action=submit`;
                let form = new FormData();
                form.append("id", this.id);
                form.append("insEmployeeMainCode", this.code);
                form.append(
                    "memberId",
                    this.recordToEdit.isMember == 1 ? this.recordToEdit.memberId : 0
                );
                await this.mAxiosPost(url, form);
                
                this.showAjaxSuccessMsg();
            } catch (error) {
                console.error(error);
            }
        },
        async saveMainEdit(options = {}) {
            const silent = options.silent === true;
            let url = API.coopInsEmployeeMemberApply;
            let form = this.buildMainFormData();
            if (this.id !== 0 && this.id) {
                form.append("id", this.id);
                url += `?action=update`;
            } else {
                url += `?action=append`;
            }

            const json = await this.mAxiosPost(url, form);
            this.id = json.resultData.id;
            if (!silent) {
                this.showAjaxSuccessMsg();
                this.$router.push({
                    name: this.$route.name,
                    params: { subId: json.resultData.id }
                });
                // this.getData();
            }
            return json;
        },
        buildMainFormData() {
            let form = new FormData();

            form.append("isMember", this.recordToEdit.isMember || "");
            form.append("account", this.recordToEdit.account || "");
            form.append("name", this.recordToEdit.name || "");
            form.append("idNumber", this.recordToEdit.idNumber || "");
            form.append("insEmployeeSubId", this.recordToEdit.insEmployeeSubId || "");
            form.append("insEmployeeYearId", this.recordToEdit.insEmployeeYearId || "");
            form.append("sex", this.recordToEdit.sex || "");
            // 統一預設值，避免後端數值/日期轉型報錯
            form.append("birthday", this.recordToEdit.birthday || "");
            form.append("title", this.recordToEdit.title || "");
            form.append("startDate", this.recordToEdit.startDate || "");
            form.append("EndDate", this.recordToEdit.EndDate || "");
            form.append("memberId", this.recordToEdit.isMember == 1 ? this.recordToEdit.memberId : 0);
            form.append("insEmployeeMainCode", this.code);
            form.append("employeeType", this.recordToEdit.employeeType);

            // 退保applyType 固定為3
            form.append("applyType", 3);

            return form;
        },
        back() {
            this.$router.push({
                name: "employeecoop_surrenderroster"
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.listFormSet ::v-deep {
    .block-content {
        padding: 0;
    }
}
</style>